<template>
  <div class="category-row">
    <cat-score-column
      :categoryName="category.name"
      :columnAScore="columnAScores.score"
      :columnBScore="columnBScores.score"
      :catIndex="catIndex">
    </cat-score-column>
    <subcat-score-column
    :subcategories="category.subcategories"
    :columnAsubcats="columnAScores.subcategories"
    :columnBsubcats="columnBScores.subcategories">
    </subcat-score-column>
  </div>
</template>

<script>
import CategoryScoreColumn from './CategoryScoreColumn';
import SubcategoryScores from './SubcategoryScores';

export default {
  name: 'category-row',
  props: ['category', 'catIndex', 'columnAScores', 'columnBScores'],
  components: {
    'cat-score-column': CategoryScoreColumn,
    'subcat-score-column': SubcategoryScores,
  },
};
</script>

<style lang="less">
  .category-row {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #555;
    
    @media(max-width: 700px) {
      flex-direction: column;
    }
  }
</style>



// WEBPACK FOOTER //
// CategoryRow.vue?5e9fca12